//@flow
import { urlsConstants } from '../_constants/urls.constant';
import { defaultService } from './defaultService';


export const saidaEstoqueService = {
  doGet,
  doSave,
  doDelete,
  findByFiltro,
};


function findByFiltro(options: Options, filter: any) {
  return defaultService.findByFiltro(`${urlsConstants.SAIDA_ESTOQUE}list`, options, filter);
}


function doDelete(id) {
  return defaultService.doDelete(`${urlsConstants.SAIDA_ESTOQUE}${id}`);
}

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.SAIDA_ESTOQUE}${id}`);
}

function doSave(estoque: any) {
  return defaultService.doSave(urlsConstants.SAIDA_ESTOQUE, estoque);
}

